document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.section-home-tabs');
  if(!section) return;

  const tabsForGroups = section.querySelectorAll('.section-home-tabs__tab.top');
  if(!tabsForGroups.length) return;

  const tabsForPanels = section.querySelectorAll('.section-home-tabs__tab.sub');

  const groups = section.querySelectorAll('.section-home-tabs__group');
  if(!groups.length) return;

  const tabPanels = section.querySelectorAll('.section-home-tabs__panel')
  if(!tabPanels.length) return

  if(tabsForGroups.length) handleGroupTabAction(tabsForGroups[0]);

  tabsForGroups.forEach(tab => tab.addEventListener('click', () => handleGroupTabAction(tab)));
  tabsForPanels.forEach(tab => tab.addEventListener('click', () => handlePanelTabAction(tab)));

  function hideElements(elements) {
    elements.forEach(element => element.classList.remove('is-active'));
  }

  function hideAllElements() {
    hideElements(groups);
    hideElements(tabPanels);
    hideElements(tabsForGroups);
    hideElements(tabsForPanels);
  }

  function handleGroupTabAction(tab) {
    hideAllElements();
    tab.classList.add('is-active');

    const themeColor = tab.getAttribute('data-theme-color');
    section.style.setProperty('--theme-color', themeColor);

    const groupID = tab.dataset.groupId;
    const groupSelector = `[data-group-id="${groupID}"]`;  

    const group = section.querySelector(`.section-home-tabs__group${groupSelector}`);
    if(!group) return;

    group.classList.add('is-active');
    
    const groupTabs = group.querySelectorAll('.section-home-tabs__tab.sub');
    const groupPanel = group.querySelector('.section-home-tabs__panels');
    if(!groupPanel) return;

    const groupPanelPanels = groupPanel.querySelectorAll('.section-home-tabs__panel');
    if(!groupPanelPanels.length) return;  

    if(groupTabs.length) groupTabs[0].classList.add('is-active');
    groupPanel.classList.add('is-active');
    groupPanelPanels[0].classList.add('is-active');
  }

  function handlePanelTabAction(tab) {
    hideElements(tabPanels);
    hideElements(tabsForPanels);
    tab.classList.add('is-active');

    const groupID = tab.dataset.groupId;
    const panelID = tab.dataset.panelId;

    const groupSelector = `[data-group-id="${groupID}"]`;
    const panelSelector = `[data-panel-id="${panelID}"]`;

    const group = section.querySelector(`.section-home-tabs__group${groupSelector}`);
    if(!group) return;

    const panels = group.querySelector(`.section-home-tabs__panels`);
    if(!panels) return;
    
    const panel = panels.querySelector(`.section-home-tabs__panel${panelSelector}`);
    if(!panel) return;

    panels.classList.add('is-active');
    panel.classList.add('is-active');
  }
})